<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option v-if="firstOption !== null" value="">{{ firstOption }}</option>
    <option
      v-for="birthday_month in selects"
      :key="birthday_month.id"
      :value="birthday_month.id"
      :selected="birthday_month.id === selected"
      >{{ birthday_month.name }}</option
    >
  </select>
</template>

<script>
export default {
  name: 'SelectMonth',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : 'Todos',
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      this.selects = [
        { id: 1, name: 'Janeiro' },
        { id: 2, name: 'Fevereiro' },
        { id: 3, name: 'Março' },
        { id: 4, name: 'Abril' },
        { id: 5, name: 'Maio' },
        { id: 6, name: 'Junho' },
        { id: 7, name: 'Julho' },
        { id: 8, name: 'Agosto' },
        { id: 9, name: 'Setembro' },
        { id: 10, name: 'Outubro' },
        { id: 11, name: 'Novembro' },
        { id: 12, name: 'Dezembro' },
      ];
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
